// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
import {OrderEventsActions, OrderEventActionTypes} from '../_actions/order-event.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
import {OrderEvent} from '..';

// Models

export interface OrderEventsState extends EntityState<OrderEvent> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastQuery: QueryParamsModel;
	lastCreatedOrderEventId: number;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<OrderEvent> = createEntityAdapter<OrderEvent>();

export const initialOrderEventsState: OrderEventsState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedOrderEventId: undefined,
	showInitWaitingMessage: true
});

export function orderEventsReducer(state = initialOrderEventsState, action: OrderEventsActions): OrderEventsState {
	switch (action.type) {
		case OrderEventActionTypes.OrderEventsPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedOrderEventId: undefined
			};
		case OrderEventActionTypes.OrderEventsActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case OrderEventActionTypes.OrderEventOnServerCreated:
			return {
				...state
			};
		// case OrderEventActionTypes.OrderEventCreated:
		// 	return adapter.addOne(action.payload.OrderEvent, {
		// 		...state, lastCreatedOrderEventId: action.payload.product.id
		// 	});
		case OrderEventActionTypes.OrderEventUpdated:
			return adapter.updateOne(action.payload.partialOrderEvent, state);
		// case OrderEventActionTypes.OrderEventsStatusUpdated: {
		// 	const _partialOrderEvents: Update<OrderEvent>[] = [];
		// 	for (let i = 0; i < action.payload.OrderEvents.length; i++) {
		// 		_partialOrderEvents.push({
		// 			id: action.payload.OrderEvents[i].id,
		// 			changes: {
		// 				status: action.payload.status
		// 			}
		// 		});
		// 	}
		// 	return adapter.updateMany(_partialOrderEvents, state);
		// }
		case OrderEventActionTypes.OneOrderEventDeleted:
			return adapter.removeOne(action.payload.id, state);
		case OrderEventActionTypes.ManyOrderEventsDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case OrderEventActionTypes.OrderEventsPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case OrderEventActionTypes.OrderEventsPageLoaded:
			return adapter.addMany(action.payload.OrderEvents, {
				...initialOrderEventsState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		default:
			return state;
	}
}

export const getOrderEventstate = createFeatureSelector<OrderEvent>('orderEvents');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
